import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

import { getBorder } from 'Components/utils';

const styles = theme => ({
  root: {
    pointerEvents: 'none',
    display: 'block',
    height: 1,
    margin: theme.spacing(2, 0),
    position: 'relative',
    textAlign: 'center',
  },
  rootShowHorizontalRule: {
    ...getBorder(theme, { top: true }),
  },
});


const Splitter = ({
  classes,
  className,
  children,
  showHorizontalRule,
  ...rest
}) => (
  <div
    className={classNames(classes.root, className, {
      [classes.rootShowHorizontalRule]: showHorizontalRule,
    })}
    {...rest}
  >
    {children}
  </div>
);

Splitter.defaultProps = {
  className: '',
  showHorizontalRule: true,
};

Splitter.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  showHorizontalRule: PropTypes.bool,
};

export default withStyles(styles)(Splitter);
